import * as GSAP from 'gsap';
import AbstractElement from "./AbstractElement";
import CarouselTab from "../components/tab/CarouselTab";
import SectionTab from "../components/tab/SectionTab";
import Product from "../components/product/Product";
import MosaicEffect from "../components/MosaicEffect";
import CSSTransitionInElement from "../components/CSSTransitionInElement";


class PerformanceElement extends AbstractElement {


    constructor(template: JQuery) {
        super(template);
    }


    resize(): void {
        this.update();
    }

    update(scrollTop?: number): void {
        if (this.banner) this.banner.update(scrollTop, window.innerHeight / 3);
        if (this.title) this.title.update(scrollTop, window.innerHeight / 3);
        if (this.desc) this.desc.update(scrollTop, window.innerHeight / 3);
        if (this.divider) this.divider.update(scrollTop, window.innerHeight / 2);
        if (this.mosaic) this.mosaic.update(scrollTop, window.innerHeight / 3);
    }

    private banner: CSSTransitionInElement;
    private title: CSSTransitionInElement;
    private desc: CSSTransitionInElement;
    private divider: CSSTransitionInElement;
    private mosaic: MosaicEffect;

    init(): void {

        const $intro = this.template.find('.section__intro');
        this.banner = new CSSTransitionInElement($intro.find('.section__banner'));
        this.title = new CSSTransitionInElement($intro.find('.section__info__title'));
        this.desc = new CSSTransitionInElement($intro.find('.section__info__desc'));
        this.divider = new CSSTransitionInElement(this.template.find('.tab__divider'));
        this.mosaic = new MosaicEffect(this.template.find('.mosaic'));
        this.initTabs();
    }


    private initTabs(): void {

        const tabPerformance = new SectionTab(this.template.find('#tabPerformance'));
        tabPerformance.changeBgColor('#0f0f0f');

        const tabPowerSolution = new CarouselTab(this.template.find('#tabPowerSolution'));
        tabPowerSolution.emitter.on('CAROUSEL_REFRESHED', () => {
            tabPerformance.changeContentHeight();
        });
        tabPowerSolution.emitter.on('CHANGE_BG_COLOR', (data: any) => {
            tabPerformance.changeBgColor(data.bgColor);
        });
        tabPowerSolution.emitter.on('CAROUSEL_CHANGED', (data: any) => {
            const $transient = this.template.find('.transient');
            if (data.id == 1) {
                $transient.find('.product__cover:eq(0)').addClass('active');
                $transient.find('.product__cover:eq(0)').attr('src', './assets/img/performance/product-transient-1.gif');
                window.setTimeout(() => {
                    $transient.find('.product__cover:eq(1)').addClass('active');
                    $transient.find('.product__cover:eq(1)').attr('src', './assets/img/performance/product-transient-2.gif');
                }, 2100);
            } else {
                $transient.find('.product__cover').removeClass('active');
                $transient.find('.product__cover').css('background-image', 'none');
            }

            if (data.id == 4) {
                $('#productPowerDesign').find('.product__cover').addClass('active');
            } else {
                $('#productPowerDesign').find('.product__cover').removeClass('active');
            }
        });
        tabPowerSolution.initCarousel({
            items: 1,
            loop: false,
            margin: 0,
            nav: false,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            autoHeight: true
        });
        this.template.find('.video__cover').each((index, element) => {
            $(element).on('click tap', e => {
                if ($(e.currentTarget).hasClass('active')) {
                    $(e.currentTarget).children('video').trigger('pause');
                    $(e.currentTarget).removeClass('active');
                } else {
                    $(e.currentTarget).children('video').trigger('play');
                    $(e.currentTarget).addClass('active');
                }
            });
        });

        const $teamed = this.template.find('.teamed');
        $teamed.find('.product__info__toggle').on('click tap', e => {
            if ($(e.currentTarget).hasClass('active')) {
                $(e.currentTarget).removeClass('active');
                $teamed.find('.product__info__img').removeClass('active');
            } else {
                $(e.currentTarget).addClass('active');
                $teamed.find('.product__info__img').addClass('active');
            }
        });

        /*const tabPowerArchitecture = new CarouselTab(this.template.find('#tabPowerArchitecture'));
        tabPowerArchitecture.emitter.on('CAROUSEL_REFRESHED', () => {
            tabPowerSolution.refreshCarousel();
        });
        tabPowerArchitecture.initCarousel({
            items: 1,
            loop: false,
            margin: 10,
            nav: false,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            autoHeight: true
        });*/

        const productPowerDesign = new Product(this.template.find('#productPowerDesign'));
        productPowerDesign.emitter.on('CAROUSEL_REFRESHED', () => {
            tabPerformance.changeContentHeight();
        });
    }


}

export default PerformanceElement;